import axios from '@/api/config';

const shareReferrerLog = {
  getShareReferrerLogById(data) {
    return axios.get(`${process.env.BASE_URL}/shareReferrerLog/getShareReferrerLogById/` + data, {});
  },
  getShareReferrerLogDetail(data) {
    return axios.get(`${process.env.BASE_URL}/shareReferrerLog/getShareReferrerLogDetail`, {params: data});
  },
  getShareReferrerLog(data) {
    return axios.get(`${process.env.BASE_URL}/shareReferrerLog/getShareReferrerLog`, {params: data});
  },
  getShareReferrerLogList(data) {
    return axios.get(`${process.env.BASE_URL}/shareReferrerLog/getShareReferrerLogList`, {params: data});
  },
  getShareReferrerLogTree(data) {
    return axios.get(`${process.env.BASE_URL}/shareReferrerLog/getShareReferrerLogTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/shareReferrerLog/pageList`, data);
  },
  addShareReferrerLog(data) {
    return axios.post(`${process.env.BASE_URL}/shareReferrerLog/addShareReferrerLog`, data);
  },
  updateShareReferrerLog(data) {
    return axios.put(`${process.env.BASE_URL}/shareReferrerLog/updateShareReferrerLog`, data);
  },
  deleteShareReferrerLog(data) {
    return axios.delete(`${process.env.BASE_URL}/shareReferrerLog/deleteShareReferrerLog`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/shareReferrerLog/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/shareReferrerLog/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/shareReferrerLog/active`, data);
  },
}
export default shareReferrerLog;



// WEBPACK FOOTER //
// ./src/api/shareReferrerLog.js